"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _Stack = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Stack"));
var _SocialButton = _interopRequireDefault(require("@kiwicom/orbit-components/lib/SocialButton"));
var _Loading2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Loading"));
var _Text3 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Text"));
var _context = require("../../../../services/auth/context");
var _facebook = require("../../../../services/auth/services/facebook");
var _google = require("../../../../services/auth/services/google");
var _apple = require("../../../../services/auth/services/apple");
var _errors = require("../../consts/errors");
var _jsxRuntime = require("react/jsx-runtime");
var _Loading, _Text, _Text2;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const LoginViaSocials = _ref => {
  let {
    onGoogleLogin,
    onFacebookLogin,
    onAppleLogin,
    googleError,
    facebookError
  } = _ref;
  const loading = (0, _context.useIsUserLoading)();
  (0, _facebook.loadFacebookSdk)();
  (0, _google.loadGoogleSdk)();
  (0, _apple.loadAppleSdk)();

  // Error google auth returns when user tries to sign in with 3rd party cookies blocked
  const hasGoogleError = googleError === _errors.GoogleErrorMessage.IFRAME_INITIALIZATION_FAILED;
  const hasFacebookError = facebookError != null;
  if (loading) {
    return _Loading || (_Loading = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading2.default, {
      loading: true,
      type: "boxLoader"
    }));
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
      spacing: hasGoogleError ? "XSmall" : undefined,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SocialButton.default, {
        dataTest: "MagicLogin-LoginViaFacebook",
        type: "facebook",
        fullWidth: true,
        onClick: onFacebookLogin,
        children: "Facebook"
      }), hasFacebookError && (_Text || (_Text = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text3.default, {
        type: "critical",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          id: "common.error"
        })
      })))]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
      spacing: hasGoogleError ? "XSmall" : undefined,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SocialButton.default, {
        dataTest: "MagicLogin-LoginViaGoogle",
        type: "google",
        fullWidth: true,
        onClick: onGoogleLogin,
        children: "Google"
      }), hasGoogleError && (_Text2 || (_Text2 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text3.default, {
        type: "critical",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          id: "account.login.error.disabled_cookies"
        })
      })))]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SocialButton.default, {
      dataTest: "MagicLogin-LoginViaApple",
      type: "apple",
      fullWidth: true,
      onClick: onAppleLogin,
      children: "Apple"
    })]
  });
};
var _default = exports.default = LoginViaSocials;